import React from 'react';

import Button from '../../components/ButtonNew';
import {useAnalytics} from '../../hooks';

const AddInterviewCard = ({tag}) => {
  const {tracker} = useAnalytics();

  return (
    <div className="bg-gray-100 rounded-lg py-4 px-5 flex justify-between items-center flex-col sm:flex-row">
      <div className="flex items-center mb-3 sm:mb-0">
        {tag.image_url && (
          <img src={tag.image_url} alt={`${tag.name} logo`} className="h-8 w-8 mr-4 rounded-full object-contain" />
        )}
        <span className="text-sm font-medium text-gray-600 mr-5">
          {`Share your ${tag.name} interview experience and get answers from the Exponent community.`}
        </span>
      </div>
      <Button
        href="/questions/contribute"
        onClick={() => tracker.hubClickContribute()}
        className="flex-shrink-0 w-full sm:w-auto"
      >
        Add interview
      </Button>
    </div>
  );
};

export default AddInterviewCard;
